/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Detail_ForbiddenInputs */

const vi_order_detail_forbidden = /** @type {(inputs: Order_Detail_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không có quyền xem đơn này.`)
};

/**

* @param {Order_Detail_ForbiddenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_detail_forbidden = /** @type {((inputs?: Order_Detail_ForbiddenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Detail_ForbiddenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_detail_forbidden(inputs)
});